import getDistance from "geolib/es/getDistance";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { getLeafRating } from "../../../util/leafRating";
import RestaurantResult from "./RestaurantResult";

/**
 * Filter restaurant by leaf rating (count and verification tier)
 */
const filterByLeafRating = (restaurant, minLeafCount, verificationTier) => {
  const rating = getLeafRating(restaurant);

  // Check minimum leaf count
  if (minLeafCount && rating.count < minLeafCount) return false;

  // Check verification tier
  if (verificationTier === "verified" && rating.tier !== "green-solid") {
    return false;
  }
  if (verificationTier === "guaranteed" && rating.tier === "gray") {
    return false;
  }

  return true;
};

const Restaurant = ({
  restaurants,
  isOpen,
  selectedCuisines,
  currentLocation,
  minLeafCount,
  verificationTier,
  collapseSheet,
}) => {
  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get("keywords");
  const filterBasedOnSelectedCuisines = (restaurant) =>
    Object.values(selectedCuisines).length === 0 ||
    restaurant.cuisine.filter((cuisine) =>
      Object.values(selectedCuisines).includes(cuisine)
    ).length > 0;

  // Note: keyword filtering is handled by backend, not FE
  const filteredRestaurants =
    restaurants !== null && restaurants.length > 0
      ? restaurants
          .filter(filterBasedOnSelectedCuisines)
          .filter((restaurant) =>
            filterByLeafRating(restaurant, minLeafCount, verificationTier)
          )
          .sort((a, b) => {
            if (
              getDistance(currentLocation, a.geoJson.coordinates) <
              getDistance(currentLocation, b.geoJson.coordinates)
            ) {
              return -1;
            } else if (
              getDistance(currentLocation, a.geoJson.coordinates) ===
              getDistance(currentLocation, b.geoJson.coordinates)
            ) {
              return a.name < b.name ? -1 : 1;
            } else {
              return 1;
            }
          })
      : [];

  const hasActiveFilters =
    minLeafCount !== null || verificationTier !== null;

  return (
    <Fragment>
      {filteredRestaurants.length > 0 ? (
        filteredRestaurants.map((restaurant) => (
          <RestaurantResult
            key={restaurant._id}
            restaurant={restaurant}
            isOpen={isOpen}
            collapseSheet={collapseSheet}
            searchQuery={searchQuery}
          />
        ))
      ) : restaurants !== null && restaurants.length > 0 && hasActiveFilters ? (
        <div className="empty-state">
          <div className="empty-state-icon">
            <i className="fas fa-filter" />
          </div>
          <div className="empty-state-title">No results match your filters</div>
          <div className="empty-state-message">
            Try adjusting your keyword or filter settings
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

Restaurant.propTypes = {
  restaurants: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
  currentLocation: state.currentLocation,
  restaurants: state.restaurant.restaurants,
  selectedCuisines: state.selectedCuisines,
  noData: state.restaurant.noData,
  minLeafCount: state.filters.minLeafCount,
  verificationTier: state.filters.verificationTier,
});
export default connect(mapStateToProps)(Restaurant);
